import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import ParentSize from '@visx/responsive/lib/components/ParentSize';
import classNames from 'classnames';
import { Skeleton } from '@material-ui/lab';

const styles = theme => ({
  root: {
    display: 'flex',
    position: 'relative',
  },
  wrapper: {
    fontSize: 0, // a font size greater than 0 will make it so that height continues to grow
    display: 'flex',
    position: 'relative',
    minHeight: theme.dimensions.md,
    minWidth: theme.dimensions.md,
    flexGrow: 1,
    alignItems: 'center',
    justifyContent: 'center',
  },
  skeleton: {
    alignSelf: 'center',
    margin: 'auto',
  },
  select: {
    minWidth: theme.dimensions.xs,
  },
});

function CircleChart({
  className,
  classes,
  showSkeleton,
  loading,
  ChartComponent,
  ChartProps,
}) {
  if (!ChartComponent) throw new TypeError('ChartComponent must be a valid React component');

  return (
    <div className={classNames(classes.root, className)}>
      <ParentSize className={classes.wrapper}>
        {({ width, height }) => (showSkeleton ? (
          <div>
            <Skeleton
              animation="wave"
              variant="circle"
              width={height / 1.2}
              height={height / 1.2}
            />
          </div>
        ) : (
          <ChartComponent
            loading={loading}
            width={width}
            height={height}
            {...ChartProps}
          />
        ))
        }
      </ParentSize>
    </div>
  );
}

CircleChart.propTypes = {
  ChartProps: PropTypes.node,
  ChartComponent: PropTypes.node.isRequired,
  classes: PropTypes.object.isRequired,
  className: PropTypes.string,
  portfolio: PropTypes.object.isRequired,
  loading: PropTypes.bool.isRequired,
};

CircleChart.defaultProps = {
  ChartProps: {},
  className: '',
};

export default withStyles(styles)(CircleChart);
